import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between mb-x1" }

import { PersonalOfferItemPrice } from '@/b2c/shared/api/server-apis';
import useGlobalLabels from '@/shared/content/useGlobalLabels';
import { GlobalLabels } from '@/shared/content/site-context.store';
import LogInOrSignUpLinks from '@/b2c/profile/ui/LogInOrSignUpLinks.vue';
import authStore from '@/shared/auth/auth.store';


export default /*#__PURE__*/_defineComponent({
  __name: 'RegularItemNonMemberPrice',
  props: {
    price: null
  },
  setup(__props: any) {



const globalLabels = useGlobalLabels(GlobalLabels.product);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("p", _hoisted_1, [
      _createElementVNode("span", null, _toDisplayString(_unref(globalLabels).nonMemberDiscountText), 1),
      _createElementVNode("span", null, _toDisplayString(__props.price.salesPriceTotal.amount), 1)
    ]),
    (!_unref(authStore).isSignedIn)
      ? (_openBlock(), _createBlock(LogInOrSignUpLinks, {
          key: 0,
          class: "block mb-x2"
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})